module.exports = __webpack_public_path__ + "static/img/backer-image.9657381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/story-walk/backer-image.png
// module id = 697
// module chunks = 0